import { Injectable } from '@angular/core';
import { isProjectScope } from '@frontend-site/project/domain';
import { SystemStore } from '@frontend-site/shared/core';
import { RouteChangeHandler, RouterState } from '@frontend-site/shared/router-store';
import { BehaviorSubject, Observable } from 'rxjs';
import { isSystemScope } from '../utils';

@Injectable({ providedIn: 'root' })
export class SystemDetailsCleanerService implements RouteChangeHandler {
    private readonly isInScopeSubject = new BehaviorSubject<boolean>(false);
    readonly isInScope$: Observable<boolean> = this.isInScopeSubject.asObservable();

    constructor(private readonly systemStore: SystemStore) {}

    handleRouteChange(route: RouterState): void {
        const wasInScope = this.isInScopeSubject.getValue();
        const currentlyInScope = isSystemScope(route);
        const isInProjectScope = isProjectScope(route);

        this.clearSystemIfExitedAndNotInProject(currentlyInScope, wasInScope, isInProjectScope);
        this.updateInScope(currentlyInScope);
    }

    private clearSystemIfExitedAndNotInProject(currentlyInScope: boolean, wasInScope: boolean, inProjectScope: boolean): void {
        const isExitedScope = wasInScope && !currentlyInScope;
        if (isExitedScope && !inProjectScope) {
            this.systemStore.clearSelectedSystemId();
        }
    }
    private updateInScope(isInScope: boolean): void {
        this.isInScopeSubject.next(isInScope);
    }
}
